import supabase from './supabaseClient'

class SupabaseTagService {
    async list() {
        const { data, error } = await supabase
            .from('tags')
            .select('id, name, color, usage_count, created_at, updated_at')
            .order('usage_count', { ascending: false })
        if (error) throw new Error(error.message)
        return data || []
    }

    async listByUsageCursor({ limit = 12, cursor = null } = {}) {
        let query = supabase
            .from('tags')
            .select('id, name, color, usage_count, created_at, updated_at')
            .order('usage_count', { ascending: false })
            .order('id', { ascending: true })

        if (cursor && cursor.usage_count !== undefined && cursor.id) {
            // keyset: (usage_count, id) < (cursor.usage_count, cursor.id) in desc/asc composite
            // That means: usage_count = cursor.usage_count AND id > cursor.id OR usage_count < cursor.usage_count
            query = query.or(`and(usage_count.eq.${cursor.usage_count},id.gt.${cursor.id}),usage_count.lt.${cursor.usage_count}`)
        }

        const { data, error } = await query.limit(limit)
        if (error) throw new Error(error.message)
        const items = data || []
        const next = items.length === limit ? { usage_count: items[items.length - 1].usage_count, id: items[items.length - 1].id } : null
        return { items, nextCursor: next }
    }

    async create({ name }) {
        const { data: created, error: createError } = await supabase
            .from('tags')
            .insert({ name })
            .select('id, name, color, usage_count, created_at, updated_at')
            .single()
        if (createError) throw new Error(createError.message)
        // 颜色由数据库触发器自动生成
        return created
    }

    async update(id, { name }) {
        const { data, error } = await supabase
            .from('tags')
            .update({ name })
            .eq('id', id)
            .select('id, name, color, usage_count, created_at, updated_at')
            .single()
        if (error) throw new Error(error.message)
        return data
    }

    async remove(id) {
        const { error } = await supabase
            .from('tags')
            .delete()
            .eq('id', id)
        if (error) throw new Error(error.message)
        return true
    }

    // 获取标签统计
    async getStats() {
        try {
            const { count, error } = await supabase
                .from('tags')
                .select('*', { count: 'exact', head: true })

            if (error) throw error

            return {
                tagCount: count || 0
            }
        } catch (error) {
            console.error('获取标签统计失败:', error)
            throw new Error(error.message)
        }
    }
}

const supabaseTagService = new SupabaseTagService()
export default supabaseTagService 